import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const mobileTopBarOpenSelector = (state: AppState) => state.frontendState.mobileUI.topBarOpen;
export const useMobileTopBarOpenSelector = () => useSelector(mobileTopBarOpenSelector);
